function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { message, Descriptions } from "antd";
import NewAppointment from "./forms/NewAppointment";
import Common from "./includes/Common";
import { PhoneFill } from 'react-bootstrap-icons';
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Appointment = function Appointment() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    appointments = _useState2[0],
    setAppiontments = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dataChanged = _useState6[0],
    setDataChanged = _useState6[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getappointments/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setAppiontments(response.data.appointments);
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: "white-bg cool-radius",
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsxs(Col, {
            lg: 7,
            md: 8,
            children: [/*#__PURE__*/_jsx("h4", {
              children: "MES RENDEZ-VOUS"
            }), appointments.map(function (a) {
              return /*#__PURE__*/_jsxs(Descriptions, {
                style: {
                  marginBottom: '10px'
                },
                size: "small",
                bordered: true,
                column: 1,
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Patient"
                  }),
                  children: a.customer.firstname + " " + a.customer.lastname + " (" + a.customer.idnumber + ")"
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Raison",
                  children: a.reason
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Date",
                  children: /*#__PURE__*/_jsx(Moment, {
                    locale: "Fr",
                    format: "DD/MM/YYYY hh:mm",
                    children: a.date
                  })
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx(PhoneFill, {
                    size: 20
                  }),
                  children: a.customer.mobile.slice(3)
                })]
              }, a.id);
            }), isDataLoading && appointments.length == 0 && /*#__PURE__*/_jsx("div", {
              children: "Vous n'avez aucun rendez-vous"
            })]
          }), /*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 4,
            children: /*#__PURE__*/_jsx("div", {
              className: "cool-radius r-bg",
              children: /*#__PURE__*/_jsx(NewAppointment, {
                handler: function handler() {
                  setDataChanged(true);
                }
              })
            })
          })]
        })
      })
    })
  });
};
export default Appointment;